module.exports = __webpack_public_path__ + "img/microsoft-logo.8307ca44.svg";